/**
 * 服务能力静态路由数据
 * */

export default {
  path: '/servicePower',
  name: 'servicePower',
  component: () => import('@/views/index/components/servicePower/index.vue'),
  meta: {
    unrequireLogin: true
  }
}
